import React from "react";

const Logo = () => {
  return (
    <div className="logo">
      <img className="logo__pic" src="/images/logo.svg" alt="Sapiens" />
    </div>
  );
};

export default Logo;
